import React from 'react'

import { KebabMenuOuter, KebabmenuTrigger, KebabMenuWrapper, KebabMenuBody } from './Kebabmenu.styles'
import { Icon } from '../../shared/tr-icons'

import KebabmenuItemContainer from './kebabelements/KebabmenuItem.container'

const KebabmenuComponent = ({ open, events, extRef, actions, env, dataRow, analytics }) => {
  return (
    <div ref={extRef}>
      <KebabMenuOuter>
        <KebabmenuTrigger onClick={events.handleClick}>
          <Icon type={'ellipsisVertical'} />
        </KebabmenuTrigger>
        {open &&
        <KebabMenuWrapper>
          <KebabMenuBody>
            {actions.map((action, i) => {
              return (
                <KebabmenuItemContainer key={'kebabitem_' + i} analytics={analytics} env={env} dataRow={dataRow} actionType={action.actionType} label={action.label} action={action.action} />
              )
            })}
          </KebabMenuBody>
        </KebabMenuWrapper>
        }
      </KebabMenuOuter>
    </div>
  )
}

export default KebabmenuComponent
